module.exports = __webpack_public_path__ + "img/tittle.664dff90.png";